import React from 'react';
import './Services.css';
const Services = () => {
    return (
        <div style={{minHeight:'100vh'}}>
            <div className='service-img'>
               <img src='https://i.ibb.co/ynJr6wN/realistic-coming-soon-background-52683-59078.webp' alt=''></img>
            </div>
        </div>
    );
};

export default Services;